module.exports = __webpack_public_path__ + "static/media/2015 - 16 Karen Chan-min.0c86767c.jpg";